// T032 — No-op analytics provider.
// Used when credentials are absent (local dev, tests) so callers never need
// to null-check the provider. `checkGate` returns `false` for every gate —
// DevToolkit overrides are layered on top by `lib/analytics/index.ts:checkGate`,
// so engineers can still test an explicit local flag value.

import type { AnalyticsConfig, AnalyticsProvider, ExperimentResult } from './types';

export class NoopAnalyticsProvider implements AnalyticsProvider {
  async initialize(_config: AnalyticsConfig): Promise<void> {
    // Intentionally empty — no vendor to initialize.
  }

  checkGate(_name: string): boolean {
    return false;
  }

  getConfig(_name: string): Record<string, unknown> {
    return {};
  }

  getExperiment(_name: string): ExperimentResult {
    return { value: null, ruleID: '' };
  }

  trackEvent(_name: string, _properties: Record<string, unknown>): void {
    // Intentionally empty — events are silently dropped.
  }

  identifyUser(_userId: string, _attributes: Record<string, unknown>): void {
    // Intentionally empty — no vendor to identify with.
  }

  shutdown(): void {
    // Intentionally empty — nothing to tear down.
  }
}

export function createNoopProvider(): AnalyticsProvider {
  return new NoopAnalyticsProvider();
}
